"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEmptyExternalItem = exports.cleanupCalendarModel = exports.externalResultsToInternalResults = exports.internalToExternal = exports.externalToInternal = void 0;
const feed_factory_models_ndtrc_1 = require("@feed-factory/feed-factory.models.ndtrc");
const uuid_1 = require("uuid");
const lodash_1 = __importDefault(require("lodash"));
const date_fns_1 = require("date-fns");
const moment_1 = __importDefault(require("moment"));
const sortSingleDateItems = (a, b) => {
    if (!a.date || !b.date) {
        return 0;
    }
    if ((0, date_fns_1.format)(new Date(a.date), "yyyy-MM-dd") >
        (0, date_fns_1.format)(new Date(b.date), "yyyy-MM-dd")) {
        return 1;
    }
    if ((0, date_fns_1.format)(new Date(a.date), "yyyy-MM-dd") <
        (0, date_fns_1.format)(new Date(b.date), "yyyy-MM-dd")) {
        return -1;
    }
    // If not sorted yet: same date, so requires sorting on time
    if (!a.when[0].timestart || !b.when[0].timestart) {
        return 0;
    }
    if (a.when[0].timestart > b.when[0].timestart) {
        return 1;
    }
    if (a.when[0].timestart < b.when[0].timestart) {
        return -1;
    }
    return 0;
};
// TODO: Finish transformer by changing all language strings as described by model
const externalToInternal = (ext) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
    let transformedModel = lodash_1.default.cloneDeep(ext); // this object is gradually transformed
    // Note: without a deep clone, there is too much risk of manual errors
    // Perform validity checks
    const modelIsValid = (!transformedModel.availablefrom ||
        (0, moment_1.default)(transformedModel.availablefrom).isValid()) &&
        (!transformedModel.availableto ||
            (0, moment_1.default)(transformedModel.availableto).isValid());
    if (!modelIsValid) {
        throw new Error("Incoming data is not valid");
    }
    // Transform data structure concerning language in trcItemDetails
    if (ext.trcItemDetails) {
        let transformedTrcItemDetails = {};
        ext.trcItemDetails.forEach((detailItem) => {
            const extDetailItemClone = Object.assign({}, detailItem);
            const lang = extDetailItemClone.lang;
            delete extDetailItemClone.lang;
            transformedTrcItemDetails[lang] = extDetailItemClone;
        });
        transformedModel.trcItemDetails = transformedTrcItemDetails;
    }
    if (!transformedModel.calendar) {
        // Set empty object, as otherwise useFieldArray will malfunction in CalendarWidget
        // Does not need to be removed in internalToExternal function
        if (!ext.calendar) {
            transformedModel.calendar = {};
        }
        if (!((_a = ext.calendar) === null || _a === void 0 ? void 0 : _a.singleDates)) {
            transformedModel.calendar.singleDates = [];
        }
    }
    // Turn nested single dates items into separate items (for correct UI display/logic)
    if (transformedModel.calendar.singleDates.length > 0) {
        let extractedSingleDates = [];
        transformedModel.calendar.singleDates.forEach((date) => {
            // Only transform if when-length is more than one
            if (date.when.length <= 1) {
                extractedSingleDates.push(date);
                return;
            }
            date.when.forEach((when) => {
                const splitSingleDate = Object.assign({}, date);
                splitSingleDate.when = [when];
                extractedSingleDates.push(splitSingleDate);
            });
        });
        transformedModel.calendar.singleDates = extractedSingleDates;
    }
    // Add id field to single dates
    if (transformedModel.calendar.singleDates.length > 0) {
        (_c = (_b = transformedModel.calendar) === null || _b === void 0 ? void 0 : _b.singleDates) === null || _c === void 0 ? void 0 : _c.forEach((singleDate, index) => {
            const extSingleDateClone = Object.assign({}, singleDate);
            extSingleDateClone.id = (0, uuid_1.v4)();
            transformedModel.calendar.singleDates[index] = extSingleDateClone;
        });
    }
    // Sort singleDates, and make sure dates are in in string format
    transformedModel.calendar.singleDates =
        transformedModel.calendar.singleDates.sort(sortSingleDateItems);
    // Add NONE calendar type if missing
    if (!transformedModel.calendar.calendarType) {
        transformedModel.calendar.calendarType = "NONE";
    }
    // Add id field to priceElements
    if (ext.priceElements) {
        transformedModel.priceElements = (_d = transformedModel.priceElements) === null || _d === void 0 ? void 0 : _d.map((priceEl, index) => {
            const extPriceElClone = Object.assign({}, priceEl);
            extPriceElClone.id = (0, uuid_1.v4)();
            return extPriceElClone;
        });
    }
    // Add id field to pattern dates
    if ((_e = ext.calendar) === null || _e === void 0 ? void 0 : _e.patternDates) {
        transformedModel.calendar.patternDates =
            (_g = (_f = transformedModel.calendar) === null || _f === void 0 ? void 0 : _f.patternDates) === null || _g === void 0 ? void 0 : _g.map((patternDate, index) => {
                const extClone = Object.assign({}, patternDate);
                extClone.id = (0, uuid_1.v4)();
                return extClone;
            });
    }
    // Add id field to opens dates
    if ((_h = ext.calendar) === null || _h === void 0 ? void 0 : _h.opens) {
        transformedModel.calendar.opens = (_k = (_j = transformedModel.calendar) === null || _j === void 0 ? void 0 : _j.opens) === null || _k === void 0 ? void 0 : _k.map((date, index) => {
            const extClone = Object.assign({}, date);
            extClone.id = (0, uuid_1.v4)();
            return extClone;
        });
    }
    // Add id field to closeds dates
    if ((_l = ext.calendar) === null || _l === void 0 ? void 0 : _l.closeds) {
        transformedModel.calendar.closeds = (_o = (_m = transformedModel.calendar) === null || _m === void 0 ? void 0 : _m.closeds) === null || _o === void 0 ? void 0 : _o.map((date, index) => {
            const extClone = Object.assign({}, date);
            extClone.id = (0, uuid_1.v4)();
            return extClone;
        });
    }
    // Set activation state of pattern date items and make complete the expected object (with all days)
    if ((_p = ext.calendar) === null || _p === void 0 ? void 0 : _p.patternDates) {
        transformedModel.calendar.patternDates =
            (_r = (_q = transformedModel.calendar) === null || _q === void 0 ? void 0 : _q.patternDates) === null || _r === void 0 ? void 0 : _r.map((patternDate, index) => {
                const intClone = Object.assign(Object.assign({}, patternDate), { opens: [...patternDate.opens] });
                // If the item is listed at the back-end, it is (assumed) activated.
                intClone.opens = feed_factory_models_ndtrc_1.weekDaysDisplayOrder.map((weekday) => {
                    const weekdayOpen = patternDate.opens.find((open) => open.day === weekday);
                    if (weekdayOpen) {
                        weekdayOpen.activated = true;
                        return weekdayOpen;
                    }
                    else {
                        return { day: weekday, activated: false, whens: [] };
                    }
                });
                return intClone;
            });
    }
    // Determine if calendar comment has been set
    if ((_s = ext.calendar) === null || _s === void 0 ? void 0 : _s.comment) {
        transformedModel.calendar.hasComment = true;
    }
    // Add empty trcitemRelation for location items if missing
    if (ext.entitytype === "LOCATIE" && !ext.trcitemRelation) {
        transformedModel.trcitemRelation = { subItemGroups: [] };
    }
    return transformedModel;
};
exports.externalToInternal = externalToInternal;
// TODO: Finish transformer by changing all language strings as described by model
const internalToExternal = (int) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
    let transformedModel = lodash_1.default.cloneDeep(int); // this object is gradually transformed
    // Note: without a deep clone, there is too much risk of manual errors
    // Perform validity checks
    const modelIsValid = (!transformedModel.availablefrom ||
        (0, moment_1.default)(transformedModel.availablefrom).isValid()) &&
        (!transformedModel.availableto ||
            (0, moment_1.default)(transformedModel.availableto).isValid());
    if (!modelIsValid) {
        throw new Error("Form data is not valid");
    }
    // Transform data structure concerning language in trcItemDetails
    // Back-end takes order of trcItemDetails, ignoring the availableLanguages order - so, align here
    if (int.trcItemDetails) {
        let transformedTrcItemDetails = [];
        (_b = (_a = int.translations) === null || _a === void 0 ? void 0 : _a.availableLanguages) === null || _b === void 0 ? void 0 : _b.forEach((lang) => {
            const extDetailItem = lodash_1.default.cloneDeep(int.trcItemDetails[lang]);
            if (!extDetailItem) {
                throw new Error("Invalid language - trcItemDetails pairing");
            }
            extDetailItem.lang = lang;
            transformedTrcItemDetails.push(extDetailItem);
        });
        transformedModel.trcItemDetails = transformedTrcItemDetails;
    }
    if (int.calendar) {
        // Remove id field from single dates
        (_d = (_c = transformedModel.calendar) === null || _c === void 0 ? void 0 : _c.singleDates) === null || _d === void 0 ? void 0 : _d.forEach((singleDate, index) => {
            const intSingleDateClone = Object.assign({}, singleDate);
            delete intSingleDateClone.id;
            transformedModel.calendar.singleDates[index] = intSingleDateClone;
        });
    }
    if (int.calendar) {
        // Nest single date items
        const nestedSingleDates = [];
        // We need to make sure all date values are turned into strings
        const originalSingleDates = (_f = (_e = transformedModel.calendar) === null || _e === void 0 ? void 0 : _e.singleDates) === null || _f === void 0 ? void 0 : _f.map((singleDate) => {
            var _a, _b, _c, _d;
            let date = singleDate.date;
            if (singleDate.date instanceof Date) {
                date = singleDate.date.toISOString();
            }
            // Force format to be "13:00" rather than "13:00:00"
            let when = singleDate.when[0];
            if (when) {
                when.timestart = ((_b = (_a = when.timestart) === null || _a === void 0 ? void 0 : _a.match(/[0-9]+:[0-9]+/)) === null || _b === void 0 ? void 0 : _b[0]) || null;
                when.timeend = ((_d = (_c = when.timeend) === null || _c === void 0 ? void 0 : _c.match(/[0-9]+:[0-9]+/)) === null || _d === void 0 ? void 0 : _d[0]) || null;
            }
            return {
                date: date,
                when: singleDate.when,
            };
        }).sort(sortSingleDateItems);
        originalSingleDates.forEach((singleDate, index) => {
            const prevSingleDateIndex = nestedSingleDates.findIndex((date) => date.date === singleDate.date);
            if (prevSingleDateIndex === -1) {
                nestedSingleDates.push(singleDate);
            }
            else {
                const nestedSingleDate = lodash_1.default.cloneDeep(nestedSingleDates[prevSingleDateIndex]);
                if (!nestedSingleDate) {
                    console.error("Error processing single dates for export");
                    return;
                }
                nestedSingleDate.when.push(singleDate.when[0]);
                nestedSingleDates[prevSingleDateIndex] = nestedSingleDate;
            }
        });
        transformedModel.calendar.singleDates = nestedSingleDates;
    }
    if (int.priceElements) {
        // Remove id field from price elements
        transformedModel.priceElements = (_g = transformedModel.priceElements) === null || _g === void 0 ? void 0 : _g.map((priceEl, index) => {
            const intPriceElClone = Object.assign({}, priceEl);
            delete intPriceElClone.id;
            return intPriceElClone;
        });
    }
    if ((_h = int.calendar) === null || _h === void 0 ? void 0 : _h.patternDates) {
        // Remove id field from pattern dates
        transformedModel.calendar.patternDates =
            (_k = (_j = transformedModel.calendar) === null || _j === void 0 ? void 0 : _j.patternDates) === null || _k === void 0 ? void 0 : _k.map((patternDate, index) => {
                const intClone = Object.assign({}, patternDate);
                delete intClone.id;
                return intClone;
            });
    }
    if ((_l = int.calendar) === null || _l === void 0 ? void 0 : _l.opens) {
        // Remove id field from opens dates
        transformedModel.calendar.opens = (_o = (_m = transformedModel.calendar) === null || _m === void 0 ? void 0 : _m.opens) === null || _o === void 0 ? void 0 : _o.map((date, index) => {
            const intClone = Object.assign({}, date);
            delete intClone.id;
            return intClone;
        });
    }
    if ((_p = int.calendar) === null || _p === void 0 ? void 0 : _p.closeds) {
        // Remove id field from closeds dates
        transformedModel.calendar.closeds = (_r = (_q = transformedModel.calendar) === null || _q === void 0 ? void 0 : _q.closeds) === null || _r === void 0 ? void 0 : _r.map((date, index) => {
            const intClone = Object.assign({}, date);
            delete intClone.id;
            return intClone;
        });
    }
    // Only add pattern dates that are active
    if ((_s = int.calendar) === null || _s === void 0 ? void 0 : _s.patternDates) {
        transformedModel.calendar.patternDates =
            (_u = (_t = transformedModel.calendar) === null || _t === void 0 ? void 0 : _t.patternDates) === null || _u === void 0 ? void 0 : _u.map((patternDate, index) => {
                const intClone = Object.assign(Object.assign({}, patternDate), { opens: [...patternDate.opens] });
                intClone.opens = intClone.opens.filter((open) => open.activated);
                return intClone;
            });
    }
    // remove redundant elements of calendar model based on its type
    transformedModel.calendar = (0, exports.cleanupCalendarModel)(transformedModel.calendar);
    // Optimise single date storage by nesting by date
    // Purge comment field if not turned on
    if (!((_v = int.calendar) === null || _v === void 0 ? void 0 : _v.hasComment)) {
        delete transformedModel.calendar.comment;
    }
    // Force lowercase for legalowner and trim
    if (transformedModel.legalowner) {
        transformedModel.legalowner = transformedModel.legalowner
            .toLowerCase()
            .trim();
    }
    return transformedModel;
};
exports.internalToExternal = internalToExternal;
const externalResultsToInternalResults = (data) => {
    const transformedResults = data.results.map((item) => {
        return (0, exports.externalToInternal)(item);
    });
    return Object.assign(Object.assign({}, data), { results: transformedResults });
};
exports.externalResultsToInternalResults = externalResultsToInternalResults;
const cleanupCalendarModel = (calendar) => {
    const calendarCopy = lodash_1.default.cloneDeep(calendar);
    switch (calendarCopy.calendarType) {
        case "SINGLEDATES":
            // Keep single dates in place
            calendarCopy.patternDates = [];
            calendarCopy.opens = [];
            calendarCopy.closeds = [];
            calendarCopy.cancelleds = [];
            calendarCopy.soldouts = [];
            calendarCopy.onrequest = false;
            calendarCopy.alwaysopen = false;
            break;
        case "PATTERNDATES":
        case "OPENINGTIMES":
            // Keep pattern dates / opening times in place
            calendarCopy.singleDates = [];
            calendarCopy.onrequest = false;
            calendarCopy.alwaysopen = false;
            break;
        case "ALWAYSOPEN":
            calendarCopy.alwaysopen = true;
            calendarCopy.patternDates = [];
            calendarCopy.opens = [];
            calendarCopy.onrequest = false;
            break;
        case "ONREQUEST":
            calendarCopy.onrequest = true;
            calendarCopy.patternDates = [];
            calendarCopy.opens = [];
            calendarCopy.closeds = [];
            calendarCopy.cancelleds = [];
            calendarCopy.soldouts = [];
            calendarCopy.alwaysopen = false;
            break;
        default:
            // includes "NONE" and null
            calendarCopy.singleDates = [];
            calendarCopy.patternDates = [];
            calendarCopy.opens = [];
            calendarCopy.closeds = [];
            calendarCopy.cancelleds = [];
            calendarCopy.soldouts = [];
            calendarCopy.onrequest = false;
            calendarCopy.alwaysopen = false;
    }
    return calendarCopy;
};
exports.cleanupCalendarModel = cleanupCalendarModel;
// Implements mission-critical defaults otherwise not described by form
const getEmptyExternalItem = (type) => {
    return {
        id: null,
        entitytype: type,
        trcItemDetails: [],
        priceElements: [],
        calendar: {
            calendarType: "NONE",
            patternDates: [],
            singleDates: [],
            opens: [],
            closeds: [],
            soldouts: [],
            cancelleds: [],
        },
        files: [],
        availablefrom: null,
        availableto: null,
        markers: "",
        keywords: "",
        trcitemRelation: { subItemGroups: [] },
        wfstatus: "readyforvalidation",
    };
};
exports.getEmptyExternalItem = getEmptyExternalItem;
//# sourceMappingURL=ndtrcModelHelper.js.map